import { render, staticRenderFns } from "./ProfileTemplates.vue?vue&type=template&id=ec4f1d8c"
import script from "./ProfileTemplates.vue?vue&type=script&lang=js"
export * from "./ProfileTemplates.vue?vue&type=script&lang=js"
import style0 from "./ProfileTemplates.vue?vue&type=style&index=0&id=ec4f1d8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports